import { observer } from 'mobx-react-lite'
import { useAddNumberFromAppStepsContext } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppStepsContext'
import { SelectAppAndNumbersCommon } from 'pages/settings/ui/SelectAppAndNumbersCommon/SelectAppAndNumbersCommon'

export const SelectAppAndNumbers = observer(() => {
  const { nextClickHandler, selectAppAndNumbersStore } = useAddNumberFromAppStepsContext()

  return (
    <SelectAppAndNumbersCommon
      store={selectAppAndNumbersStore}
      nextClickHandler={nextClickHandler}
    />
  )
})
